export const createInterviewTurnState = () => {
  let assistantTurnCount = 0;
  let shouldListenForCurrentTurn = false;

  return {
    beginAssistantTurn() {
      assistantTurnCount += 1;
      shouldListenForCurrentTurn = true; // ✅ Listen on EVERY turn (greeting + all questions)
      return shouldListenForCurrentTurn;
    },
    reset() {
      assistantTurnCount = 0;
      shouldListenForCurrentTurn = false;
    },
    getAssistantTurnCount() {
      return assistantTurnCount;
    },
    shouldListenForCurrentTurn() {
      return shouldListenForCurrentTurn;
    },
  };
};
